export default "/images/claritick-shape-1.svg?5fadb97327a2d1f4f04097a80c1c2d09";